import { CommercialRecord, CRInformationByCRNumber, UserTaskCountDto } from '../models/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base-service.service';
import { ApiResponse } from '../models/api-response.model';
import { catchError, Observable } from 'rxjs';
import { UserSessionService } from './user-session-service';
import { CacheService } from './cashe-service';
import { Router } from '@angular/router';
import { ListItem } from 'ng-multiselect-dropdown/multiselect.model';
import { CompanyUser, EsbSbcGetActiveDelegationsByDelegateeNatIdReq, EsbSbcGetActiveDelegationsByDelegateeNatIdRes } from '../models/companyUser';
import { APP_ROUTER } from '../models/app.route';


@Injectable({
  providedIn: 'root',
})
export class CurrentUserService extends BaseService {
  private ipApiUrl = 'https://api.ipify.org?format=json';
  public userTaskCountDto: UserTaskCountDto = null;
  constructor(private http: HttpClient,
    private userSession: UserSessionService,
    private router: Router) {
    super();
  }

  getUserTasksCount(): Observable<ApiResponse<UserTaskCountDto>> {
  //   const httpHeaders: HttpHeaders = new HttpHeaders({
  //     Authorization: 'Bearer JWT-token'
  // });
    return this.http
      .get<ApiResponse<UserTaskCountDto>>(`/api/User/Counts`)
      .pipe(catchError(this.handleError));
  }
  logout() {
    // this.userSession.loggedIn.next(false);
    // this.userSession.username.next('');
    CacheService.clearCache();
    // this.router.navigateByUrl('/');
    this.router.navigate([APP_ROUTER.LOGIN]);

  }


  GetCrNumbersOwnershipData(nationalId: string) {
    return this.http
      .get<CommercialRecord[]>(`/api/Company/GetCrNumbersOwnershipData?nationalId=` + nationalId)
      .pipe(catchError(this.handleError));
  }

  GetCRInformationByCRNumber(companyUser: CompanyUser) {
    return this.http
      .post<CRInformationByCRNumber>(`/api/Company/GetCRInformationByCRNumber` , companyUser)
      .pipe(catchError(this.handleError));
  }

  IsCheckCompanyUser(userId: string) {
    return this.http
      .get<boolean>(`/api/Company/IsCheckCompanyUser?userId=` + userId)
      .pipe(catchError(this.handleError));
  }

  GetActiveDelegationsByDelegateeNatIdReq(model: EsbSbcGetActiveDelegationsByDelegateeNatIdReq) {
    return this.http
      .post<EsbSbcGetActiveDelegationsByDelegateeNatIdRes>(`/api/Company/GetActiveDelegationsByDelegateeNatIdReq` , model)
      .pipe(catchError(this.handleError));
  }

  getClientIPAddress(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>(this.ipApiUrl);
  }

  
  
  GetAgancyInfoAsync(id: string) {
    return this.http
      .post<any>(`/api/Company/GetAgancyInfoAsync?nationalId=`+id,null)
      .pipe(catchError(this.handleError));
  }

  SaveAgancy(model: any) {
    return this.http
      .post<any>(`/api/Company/SaveAgancy`,model)
      .pipe(catchError(this.handleError));
  }


}
